import { memo } from 'react'
import { createPortal } from 'react-dom'
import { useTooltipContext } from '../../provider/TooltipProvider'

/**
 * The Tooltip `Portal`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Portal (props) {
  const { children } = props
  const { tooltipRef } = useTooltipContext()

  return createPortal(children, tooltipRef.current)
}

// Memoize
export default memo(Portal)
